import { BaseRouteService } from 'core/services';

class OrderingScheduleRouteService extends BaseRouteService {
    constructor() {
        super('facility-schedule-ordering-dates');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,dateFrom,dateTo,facilityId,areaOfCareId,accountRepId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    getUserDaily(options) {
        return super.get(this.base + '/user-daily/{?embed}', null, options);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    generate(resource){
        return super.create(this.base + '/generate', resource);
    }
}

export default OrderingScheduleRouteService;